import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import "./manageOrganization.css";
import {
  getUnitAPI,
  purchaseItemsGetByFactoryId,
  getPurchasedItem,
  getAllocateMaterialItem,
} from "api";
import { withTranslation } from "react-i18next";
import moment from "moment";

class AllocateMaterialList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      materialStockList: [],
      factoryList: [],
      factoryId: "",
      factories: [],
    };
  }

  async componentDidMount() {
    this.getFactoryList();
    this.getAllocateMaterial();
  }

  async getFactoryList(inputValue) {
    const data = await getUnitAPI({
      page: 1,
      limit: 10,
      name: inputValue,
      isInternal: true,
    });
    if(data && data.data){
      this.setState({
        totalSize: data.data.count,
        factories: data.data.factories,
      });
    }
    
    if (Array.isArray(data.data.factories))
      return data.data.factories.map(x => {
        return { label: x.name, value: x.id };
      });
    else return [];
  }

  async getAllocateMaterial() {
    const materialStockList = await getAllocateMaterialItem({
      page: this.state.page,
      limit: this.state.sizePerPage,
      factoryId: this.state.factoryId,
    });
    if(materialStockList && materialStockList.data){
      this.setState({
        totalSize: materialStockList.data.count,
        materialStockList: materialStockList.data.allocateMaterials,
      });
    }
   
  }

  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getFactoryList(inputValue));
        }, 0);
      });

    const columns = [
      {
        dataField: "factoryName",
        text: `${this.props.t("Factory Name")}`,
        formatter: (cell, row) => {
          return row.purchasedItem.factory.name;
        },
      },
      {
        dataField: "username",
        text: `${this.props.t("User Name")}`,
        formatter: (cell, row) => {
          return row.user.name;
        },
      },
      {
        dataField: "roleName",
        text: `${this.props.t("Role Name")}`,
        formatter: (cell, row) => {
          return row.user.role.name;
        },
      },
      {
        dataField: "item",
        text: `${this.props.t("Item Name")}`,
        formatter: (cell, row) => {
          return (
            <div>
              {moment(row.createdAt).format("DD/MM/YYYY")} &gt;{" "}
              {row.purchasedItem.item.name}
            </div>
          );
        },
      },
      {
        dataField: "quantity",
        text: `${this.props.t("Quantity")}`,
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Assign Date")}`,
        formatter: (cell, row) => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "edit",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <Link
            to={{
              pathname: "/allocate-material",
              query: { isEdit: true, data: row },
            }}
          >
            <button className="py-2 px-2 border-0 rounded">
              <img src="images/dashboard-images/edit.svg" />
            </button>
          </Link>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getAllocateMaterial());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getAllocateMaterial()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    //meta title
    document.title = "manage organisation";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.materialStockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.materialStockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <Row>
                      <Col xl="6" lg="12">
                        <h3 className="text-black fw-bold text-uppercase">
                          {this.props.t("Allocate Material List")}
                        </h3>
                      </Col>
                      <Col
                        xxl={{ offset: "3", size: "3" }}
                        xl={{ offset: "2", size: "4" }}
                        md={{ offset: "0", size: "6" }}
                        sm={{ offset: "0", size: "12" }}
                        className="text-start text-lg-end pt-4 pt-lg-0"
                      >
                        <div className="d-flex justify-content-end">
                          <div className="">
                            <label
                              htmlFor="search"
                              className="pt-2 fs-5 pe-1 text-end pe-lg-3 d-inline"
                            >{this.props.t("Search")}</label>
                          </div>
                          <AsyncSelect
                            onChange={e => {
                              this.setState(
                                {
                                  factoryId: e.value,
                                },
                                () => this.getAllocateMaterial()
                              );
                            }}
                            
                            loadOptions={promiseOptions}
                            defaultOptions={this.state.factories.map(x => {
                              return { label: x.name, value: x.id };
                            })}
                            className="border-gray"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <h4 className="pt-4 fw-bold text-black">
                              {this.props.t("Allocate Material List")}{" "}
                            </h4>

                            <React.Fragment>
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex"></Col>
                              </Row>
                              <Row className="mb-2"></Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                                <div className="">
                                  <h5>
                                    {this.props.t("Showing")}{" "}
                                    {(this.state.page - 1) *
                                      this.state.sizePerPage +
                                      1}{" "}
                                    -{" "}
                                    {this.state.totalSize <
                                    this.state.sizePerPage
                                      ? this.state.totalSize
                                      : this.state.sizePerPage *
                                          this.state.page >=
                                        this.state.totalSize
                                      ? this.state.totalSize
                                      : this.state.sizePerPage *
                                        this.state.page}{" "}
                                    of {this.state.totalSize}
                                  </h5>
                                </div>
                                <div className="ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </React.Fragment>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(AllocateMaterialList);
